import { createStyles, makeStyles } from '@material-ui/styles';

const style = () =>
  createStyles({
    stepper: {
      display: 'flex',
      justifyContent: 'center'
    },
    step: {
      display: 'flex',
      flexDirection: 'column',
      gap: '10px',
      alignItems: 'center'
    },
    stepContentContainer: {
      display: 'flex',
      gap: '10px',
      alignItems: 'center',
      padding: '15px'
    },
    stepContent: {
      height: '40px',
      width: '40px',
      borderRadius: '10px',
      backgroundColor: 'blue',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      gap: '3px',
      color: 'white'
    },
    stepIndicator: {
      height: '2px',
      width: '100%',
      backgroundColor: 'lightgray',
      background: 'linear-gradient(to left, lightgray 50%, blue 50%) right',
      backgroundSize: '200%',
      transition: '.8s ease-out'
    },
    stepIndicatorOn: {
      backgroundPosition: 'left'
    }
  });
const useStyle = makeStyles(style);
export default useStyle;
